import React, {PureComponent} from "react"

import GenericModal from "@irati/ui/src/GenericModal"
import {H3} from "@irati/ui/src//Typography/Heading"
import {Para} from "@irati/ui/src/Labels"
import {FormattedMessage} from "@irati/utils/lang"

import {GreyBackground} from "./styled"

interface Props {
  show: boolean,
  onHide: () => void,
  onClick: () => void,
  title: string,
  topText: React.ReactNode,
  bottomText: React.ReactNode,
  backButtonText: string,
  continueButtonText: string
}

class ConfirmationPopup extends PureComponent<Props> {
  render() {
    const {title, show, onHide, onClick, topText, bottomText, backButtonText, continueButtonText} = this.props

    return (
      <GenericModal
        show={show}
        onHide={onHide}
        proceedButtonText={continueButtonText}
        dismissButtonText={backButtonText}
        onConfirm={onClick}>
        <H3 small className="text-center">
          <FormattedMessage id={title} />
        </H3>
        <GreyBackground>
          <Para center flush>
            {topText}
          </Para>
        </GreyBackground>
        <Para center marginBottom={5}>
          {bottomText}
        </Para>
      </GenericModal>
    )
  }
}

export default ConfirmationPopup
